import { BaseModel } from './base.model';

export class NavItem extends BaseModel {
  public id: number;
  public parentId: number;
  public hasSubMenu: boolean;
  public title: string;
  public routerLink: string;
  public href: string;
  public icon: string;
  public target: string;

  constructor(data) {
    if (typeof data == 'string') {
      data = JSON.parse(data);
    }

    // transform the data
    data.parentId =
      data.parent_id != undefined ? data.parent_id : data.parentId;
    data.hasSubMenu =
      data.has_children != undefined ? data.has_children : data.hasSubMenu;
    data.routerLink =
      data.router_link != undefined ? data.router_link : data.routerLink;

    delete data.parent_id;
    delete data.has_children;
    delete data.router_link;

    super(data);
  }
}
